import log from 'loglevel';

// 统一配置常量
const LOG_LEVELS = {
  PROD: 'error',
  DEV: 'debug',
};

// 使用 Vite 的环境变量
const isProduction = import.meta.env.MODE === 'production';
const envLogLevel = (import.meta.env.LOG_LEVEL || '').toLowerCase();

// 设置日志级别（优化优先级）
const defaultLevel = isProduction ? LOG_LEVELS.PROD : LOG_LEVELS.DEV;
const finalLevel = envLogLevel || defaultLevel;
log.setLevel(log.levels[finalLevel.toUpperCase()]);

// 导出增强实例
export const logger = log;
export const LOG_LEVEL = LOG_LEVELS;

// 新增方法导出
export const debug = log.debug;
export const info = log.info;
export const warn = log.warn;
export const error = log.error;
